import { PrivateInterceptor } from "../../interceptors/PrivateInterceptor"
import { PrivateInterceptorIPS } from "../../interceptors/PrivateInterceptorIPS";

export const getFirmaPersonal = async (IdPersonal) => {
        const result = await PrivateInterceptor(`payrolls/Firmas/${IdPersonal}`, 'GET');
        if(result){
            var binary = '';
            var bytes = [].slice.call(new Uint8Array(result.data));
            bytes.forEach((b) => binary += String.fromCharCode(b));
            const base64String = window.btoa(binary);
            return base64String;
        }else{
            return null;
        }
}

export const getFirmaPersonalPublic = async (IdPersonal, Token) => {
        const result = await PrivateInterceptorIPS(`Base/Firmas/${IdPersonal}`, 'GET', undefined, Token);
        if(result){
            var binary = '';
            var bytes = []?.slice?.call(new Uint8Array(result?.data));
            bytes?.forEach((b) => binary += String?.fromCharCode(b));
            const base64String = window?.btoa(binary);
            return base64String;
        }else{
            return null;
        }
}